(function() {
  var PlacementHandler, Router,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Router = App.loadClass('core::Router');

  PlacementHandler = App.loadClass('grower::handlers/placement/PlacementHandler');

  exports.PlacementRouter = (function(superClass) {
    extend(PlacementRouter, superClass);

    function PlacementRouter() {
      return PlacementRouter.__super__.constructor.apply(this, arguments);
    }

    PlacementRouter.prototype.prefix = 'Placement';

    PlacementRouter.prototype.module_name = 'PlacementRouter';

    PlacementRouter.prototype.register = function() {
      this.module = angular.module(this.module_name, ['ui.router', 'ui.bootstrap']);
      this.service('grower::Angular/Placement/PlacementService', ['$http']);
      this.controller('grower::Angular/Placement/SurveyFieldsDialogController', ['$scope', '$transitions', '$uibModalInstance', 'Placement.Services.PlacementService', 'survey_result']);
      this.service('grower::Angular/Placement/Report/ReportService', ['$http', '$window']);
      this.controller('grower::Angular/Placement/Report/DialogController', ['$scope', '$transitions', '$uibModalInstance', '$state']);
      this.controller('grower::Angular/Placement/Report/Steps/SelectYearAndCropController', ['$scope', '$transitions', 'Placement.Services.ReportService']);
      this.controller('grower::Angular/Placement/Report/Steps/SelectSurveysController', ['$scope', '$transitions', 'Placement.Services.ReportService', '$uibModal']);
      this.controller('grower::Angular/Placement/Report/Steps/DuplicateFieldsController', ['$scope', '$transitions', 'Placement.Services.ReportService']);
      this.controller('grower::Angular/Placement/Report/Steps/FarmFieldController', ['$scope', '$transitions', 'Placement.Services.ReportService', '$uibModal']);
      this.controller('grower::Angular/Placement/Report/SurveyDetailsDialogController', ['$scope', '$transitions', '$uibModalInstance', 'Placement.Services.ReportService', 'survey_result', 'field']);
      this.controller('grower::Angular/Placement/Report/PlanDetailsDialogController', ['$scope', '$transitions', '$uibModalInstance', 'Placement.Services.ReportService', 'survey_result', 'field']);
      return this.controller('grower::Angular/Placement/Report/Steps/DownloadController', ['$scope', '$transitions', 'Placement.Services.ReportService']);
    };

    PlacementRouter.prototype.registerRoutes = function($stateProvider) {
      var init_handler;
      init_handler = true;
      return $stateProvider.state('grower.placement', {
        url: '/placement',
        template: '<div></div>',
        onEnter: [
          '$state', '$ngModal', function($state, $ngModal) {
            var i, len, ref, state_name;
            init_handler = true;
            if (App.current_page instanceof PlacementHandler && $state.current.name !== 'grower.placement') {
              ref = App.current_page.angular_states;
              for (i = 0, len = ref.length; i < len; i++) {
                state_name = ref[i];
                if (_.startsWith($state.current.name, state_name)) {
                  init_handler = false;
                  break;
                }
              }
            }
            $(window).on('spp.add-planting-plan', function(event, data) {
              return $ngModal.openPlantingForm(data.field_id, data.year, null, null, data.options);
            });
            $(window).on('spp.edit-planting-plan', function(event, data) {
              return $ngModal.openPlantingForm(data.field_id, data.year, {
                layers_id: data.layer_id
              }, null, data.options);
            });
            $(window).on('spp.add-planting-rx-plan', (function(_this) {
              return function(event, data) {
                return $state.go('grower.planting-rx', {
                  id: null
                });
              };
            })(this));
            return $(window).on('spp.placement-report', (function(_this) {
              return function(event, data) {
                return $state.go('grower.placement.report');
              };
            })(this));
          }
        ],
        onExit: [
          '$state', function($state) {
            $(window).off('spp.add-planting-plan');
            $(window).off('spp.edit-planting-plan');
            return $(window).off('spp.add-planting-rx-plan');
          }
        ],
        controller: [
          '$scope', function($scope) {
            if (init_handler) {
              App.current_page = new PlacementHandler();
              return App.current_page.init();
            }
          }
        ]
      }).modalState('grower.placement.report', {
        url: '/report',
        windowClass: 'dialog_500',
        templateUrl: 'backend/grower/placement/report/dialog',
        controller: 'Placement.Controllers.DialogController'
      }).state('grower.placement.report.select_year_and_crop', {
        url: '',
        views: {
          'step_content@': {
            templateUrl: 'backend/grower/placement/report/select-year-and-crop-step',
            controller: 'Placement.Controllers.SelectYearAndCropController'
          }
        }
      }).state('grower.placement.report.select_surveys', {
        url: '',
        views: {
          'step_content@': {
            templateUrl: 'backend/grower/placement/report/select-surveys-step',
            controller: 'Placement.Controllers.SelectSurveysController'
          }
        }
      }).state('grower.placement.report.duplicate_fields', {
        url: '',
        views: {
          'step_content@': {
            templateUrl: 'backend/grower/placement/report/duplicate-fields-step',
            controller: 'Placement.Controllers.DuplicateFieldsController'
          }
        }
      }).state('grower.placement.report.farm_field', {
        url: '',
        views: {
          'step_content@': {
            templateUrl: 'backend/grower/placement/report/farm-field-step',
            controller: 'Placement.Controllers.FarmFieldController'
          }
        }
      }).state('grower.placement.report.download', {
        url: '',
        views: {
          'step_content@': {
            templateUrl: 'backend/grower/placement/report/download-step',
            controller: 'Placement.Controllers.DownloadController'
          }
        }
      });
    };

    return PlacementRouter;

  })(Router);

}).call(this);
